// TODO convert to enum
export const payMethodEnum = {
  APPLE_PAY: 'payu-jp',
  GOOGLE_PAY: 'payu-ap',
  CASH_ON_DELIVERY: 'cash_on_delivery',
}
